<p-dialog
  header="Bulk Delete Items"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: 'min(32rem, 96vw)' }"
  [breakpoints]="{ '575px': '96vw' }"
  appendTo="body"
  [(visible)]="visible"
  [closable]="!deleting"
  [closeOnEscape]="!deleting"
>
  <p class="m-0 mb-3 text-sm text-surface-switch-700">
    This will permanently delete
    <strong>
      {{ totalCount }} total {{ totalCount === 1 ? "item" : "items" }}:
    </strong>
  </p>

  <ul class="m-0 mb-4 pl-5 text-sm text-surface-switch-700 list-disc">
    <li>
      {{ selectedCount }} selected
      {{ selectedCount === 1 ? "item" : "items" }}
    </li>
    @if (nestedCount > 0) {
      <li>
        {{ nestedCount }} additional nested
        {{ nestedCount === 1 ? "subitem" : "subitems" }}
      </li>
    }
  </ul>

  <p class="m-0 text-sm text-surface-switch-600">
    This action permanently deletes these items and cannot be undone.
  </p>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2 pt-2">
      <p-button
        label="Cancel"
        severity="secondary"
        [disabled]="deleting"
        (onClick)="close()"
      />
      <p-button
        label="Delete"
        icon="pi pi-trash"
        severity="danger"
        [disabled]="selectedDeleteRoots.length === 0 || deleting"
        [loading]="deleting"
        (onClick)="deleteSelected()"
      />
    </div>
  </ng-template>
</p-dialog>
